<template>
    <div>
        <el-row>
            <el-col>
                <el-form :inline="true" :model="from" ref="from" class="demo-form-inline">
                    <el-form-item prop="name">
                        <!-- 输入框 -->
                        <!--
                            type：type类型 text/textArea（文本框）
                            size：medium / small / mini
                            rows:输入框行数，只对 type="textarea" 有效
                            autosize:自适应内容高度，只对 type="textarea" 有效，可传入对象，如，{ minRows: 2, maxRows: 6 }
                            readonly：是否只读
                            autocomplete：off/on自动补全属性
                            hasBtn：Boolean  是否为带有按钮
                            width：组件宽度
                         -->
                        <td-input
                            v-model="from.input1"
                            :maxlength="50"
                            :minlength="1"
                            type="text"
                            size="medium"
                            :clearable="true"
                            :rows="4"
                            :autosize="autosize"
                            :readonly="false"
                            autocomplete="off"
                        ></td-input>
                        <td-input
                            v-model="from.input"
                            :maxlength="50"
                            :minlength="1"
                            type="text"
                            size="medium"
                            :clearable="true"
                            :rows="4"
                            :autosize="autosize"
                            :readonly="false"
                            autocomplete="off"
                            :hasBtn="true"
                            @search="search"
                        ></td-input>
                    </el-form-item>
                    <el-form-item style="padding-left:100px" prop="name1">
                        <!-- 按钮 -->
                        <!-- size:medium/small/mini
                            type：primary/button
                            loading:加载状态
                            round:是否圆角按钮
                            permissions:满足所有权限信息
                            roles:权限角色信息（其中之一）
                            oneOfPermissions：权限之一
                        -->

                        <td-button disabled type="primary" @click="btnQuery" :permissions="stringPermissions" :role="roles" :oneOfPermissions="oneOfPermissions" :loading="loading">{{
                            $t('common.QUERY')
                        }}</td-button>
                        <td-button @click="btnAdd" :loading="true">{{ $t('common.ADD') }}</td-button>
                        <td-button type="text" @click="outerVisible = true">点击打开外层 Dialog</td-button>
                        <td-permission :permissions="stringPermissions" :role="roles" :oneOfPermissions="oneOfPermissions">
                            <div slot="noPermission">
                                <td-button slot="noPermission">无权限</td-button>
                            </div>
                            <div slot="permission">
                                <td-button slot="permission">有权限</td-button>
                            </div>
                        </td-permission>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <el-row>
            <!-- 带有搜索建议的搜索框 -->
            <td-autocomplete popper-class="my-autocomplete" v-model="state3" :fetch-suggestions="querySearch" placeholder="请输入内容" @select="handleSelect">
                <i class="el-icon-edit el-input__icon" slot="suffix" @click="handleIconClick"> </i>
                <template slot-scope="{ item }">
                    <div class="name">{{ item.value }}</div>
                    <span class="addr">{{ item.address }}</span>
                </template>
            </td-autocomplete>
        </el-row>
        <el-row>
            <!-- 表格 -->
            <!--
                hasLoading:是否加载动画
                hasMutiSelect:是否加载多选框
                hasIndex:是否加载序号列
                height:表格高度
                hasPage:是否加载分页
                simplePage:是否使用简单分页（侧重功能）
                smallPage:是否使用mini分页 （侧重尺寸
                pageSizes:分页情况 默认[10, 30, 50, 100, 300, 500]
                columns:表头信息
                pageSize：每页条数
                currentPage：当前页
                total:总条数
             -->
            <td-table
                :columns="columns"
                :dataSource="tableData"
                :pageSize="pageSize"
                :currentPage="currentPage"
                :total="total"
                :hasDraggable="true"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
                @select="select"
                @selectAll="selectAll"
                ref="table"
            >
                <!-- 展开项功能示例 -->
                <td-table-column type="expand">
                    <template slot-scope="props">
                        <el-form label-position="left" inline class="demo-table-expand">
                            <el-form-item label="名称">
                                <span>{{ props.row.name }}</span>
                            </el-form-item>
                            <el-form-item label="类型">
                                <span>{{ props.row.type }}</span>
                            </el-form-item>
                        </el-form>
                    </template>
                </td-table-column>
            </td-table>
            <!-- 正常dialog
                        title：Dialog 的标题
                        visible：是否显示 Dialog，支持 .sync 修饰符
                        fullscreen：是否为全屏 Dialog
                        modal:是否需要遮罩层
                        lockScroll:是否在 Dialog 出现时将 body 滚动锁定
                        custom-class:Dialog 的自定义类名
                        close-on-click-modal: 是否可以通过点击 modal 关闭 Dialog
                        close-on-press-escape:是否可以通过按下 ESC 关闭 Dialog
                        show-close:是否显示关闭按钮
                        center:是否对头部和底部采用居中布局
                        before-close:关闭前的回调，会暂停 Dialog 的关闭
                        width：
                        style：
                        modal-append-to-body：遮罩层是否插入至 body 元素上，若为 false，则遮罩层会插入至 Dialog 的父元素上
                        append-to-body：Dialog 自身是否插入至 body 元素上。嵌套的 Dialog 必须指定该属性并赋值为 true
                        v-dialogDrag：dialog可拖拽指令
                     -->
            <td-dialog :visible="visible" @cancel="visible = false" title="添加" width="30%" :before-close="dialogClose">
                <span>这是一段信息</span>
                <!-- <span slot="footer" class="dialog-footer">
                            <td-button @click="visible = false">取 消</td-button>
                            <td-button type="primary" @click="visible = false">确 定</td-button>
                        </span> -->
            </td-dialog>
            <!--嵌套dialog
                     正常情况下，我们不建议使用嵌套的 Dialog，如果需要在页面上同时显示多个 Dialog，可以将它们平级放置
                       -->

            <td-dialog title="外层 Dialog" :visible.sync="outerVisible" v-if="outerVisible" :before-close="outerVisibleFnc">
                <td-dialog width="30%" title="内层 Dialog" :visible.sync="innerVisible" :before-close="innerVisibleFnc" append-to-body> </td-dialog>
                <div slot="footer" class="dialog-footer">
                    <td-button @click="outerVisible = false">取 消</td-button>
                    <td-button type="primary" @click="innerVisible = true">打开内层 Dialog</td-button>
                </div>
            </td-dialog>
        </el-row>
    </div>
</template>
<script>
export default {
    data() {
        return {
            outerVisible: false,
            innerVisible: false,
            visible: false,
            value: '',
            options: [
                {
                    value: '选项1',
                    label: '黄金糕'
                },
                {
                    value: '选项2',
                    label: '双皮奶'
                },
                {
                    value: '选项3',
                    label: '蚵仔煎'
                },
                {
                    value: '选项4',
                    label: '龙须面'
                },
                {
                    value: '选项5',
                    label: '北京烤鸭'
                }
            ],
            stringPermissions: ['userInfo:view', 'userInfo:add'],
            oneOfPermissions: ['userInfo:view'],
            roles: ['admin'],
            from: {
                name: '',
                name1: '',
                input: '',
                input1: '',
                inputQuery: ''
            },
            autosize: { minRows: 2, maxRows: 6 },
            loading: false,
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            columns: [
                // 表头数据
                {
                    prop: 'name',
                    label: 'common.NAME',
                    align: 'center'
                },
                {
                    prop: 'type',
                    label: 'common.',
                    align: 'center',
                    render: (createElement, params) => {
                        if (params.row.type === 'NVR') {
                            return createElement('span', 'NVR');
                        }
                        return createElement('span', this.$t('common.UNKNOW_TYPE'));
                    }
                },
                {
                    prop: '',
                    label: 'common.OPERATE',
                    tableWidth: '150',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'el-button',
                                {
                                    props: { type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnExit(params.row);
                                        }
                                    }
                                },
                                this.$t('common.EDIT')
                            ),
                            createElement(
                                'el-button',
                                {
                                    props: { type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.delete(params.row.id);
                                        }
                                    }
                                },
                                this.$t('common.DELETE')
                            )
                        ]);
                    }
                }
            ],
            tableData: [
                {
                    id: 'id',
                    name: '主机',
                    type: 'NVR',
                    item: [
                        {
                            id: 'id',
                            name: '主机',
                            type: 'NVR'
                        }
                    ]
                },
                {
                    id: 'id1',
                    name: '主机2',
                    type: 'NVR1'
                }
            ],
            restaurants: [],
            state3: ''
        };
    },
    methods: {
        search(val) {
            this.$message({
                message: '您要检索的关键字为：' + val,
                type: 'success'
            });
        },
        /* button相关 */
        /* 添加 */
        btnAdd() {
            this.$message({
                message: '我是添加按钮',
                type: 'success'
            });
            this.visible = true;
        },
        /* 查询 */
        btnQuery() {
            this.$message({
                message: '您要检索的关键字为：' + this.from.input,
                type: 'success'
            });
        },
        /* 表格相关 */
        /* 编辑 */
        btnExit(item) {
            const h = this.$createElement;
            this.$message({
                message: h('p', null, [h('span', null, item.name)])
            });
        },
        /* 删除 */
        delete(id) {
            this.$message({ message: id, type: 'warning' });
        },
        /* 每页条数改变时时触发的事件 */
        handleSizeChange(val) {},
        /* 当前页改变时触发的事件 */
        currentChange(val) {},
        /* 选择后实时回调 selection所有选择行信息，row最新选中行信息 */
        select(selection, row) {},
        /* 全选后实时回调，selection所有选择行信息 */
        selectAll(selection) {},
        getSelectAllRows() {
            /* 所有选择的行信息 */
            let array = this.$refs.table.getSelectAllRows();
        },
        /* dialog 相关 */
        dialogClose() {
            this.visible = false;
        },
        innerVisibleFnc() {
            this.innerVisible = false;
        },
        outerVisibleFnc() {
            this.outerVisible = false;
        },
        querySearch(queryString, cb) {
            var restaurants = this.restaurants;
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createFilter(queryString) {
            return restaurant => {
                return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
            };
        },
        loadAll() {
            return [
                { value: '三全鲜食（北新泾店）', address: '长宁区新渔路144号' },
                { value: 'Hot honey 首尔炸鸡（仙霞路）', address: '上海市长宁区淞虹路661号' },
                { value: '新旺角茶餐厅', address: '上海市普陀区真北路988号创邑金沙谷6号楼113' },
                { value: '泷千家(天山西路店)', address: '天山西路438号' },
                { value: '胖仙女纸杯蛋糕（上海凌空店）', address: '上海市长宁区金钟路968号1幢18号楼一层商铺18-101' },
                { value: '贡茶', address: '上海市长宁区金钟路633号' },
                { value: '豪大大香鸡排超级奶爸', address: '上海市嘉定区曹安公路曹安路1685号' },
                { value: '茶芝兰（奶茶，手抓饼）', address: '上海市普陀区同普路1435号' },
                { value: '十二泷町', address: '上海市北翟路1444弄81号B幢-107' },
                { value: '星移浓缩咖啡', address: '上海市嘉定区新郁路817号' },
                { value: '阿姨奶茶/豪大大', address: '嘉定区曹安路1611号' },
                { value: '新麦甜四季甜品炸鸡', address: '嘉定区曹安公路2383弄55号' },
                { value: 'Monica摩托主题咖啡店', address: '嘉定区江桥镇曹安公路2409号1F，2383弄62号1F' },
                { value: '浮生若茶（凌空soho店）', address: '上海长宁区金钟路968号9号楼地下一层' },
                { value: 'NONO JUICE  鲜榨果汁', address: '上海市长宁区天山西路119号' },
                { value: 'CoCo都可(北新泾店）', address: '上海市长宁区仙霞西路' },
                { value: '快乐柠檬（神州智慧店）', address: '上海市长宁区天山西路567号1层R117号店铺' },
                { value: 'Merci Paul cafe', address: '上海市普陀区光复西路丹巴路28弄6号楼819' },
                { value: '猫山王（西郊百联店）', address: '上海市长宁区仙霞西路88号第一层G05-F01-1-306' },
                { value: '枪会山', address: '上海市普陀区棕榈路' },
                { value: '纵食', address: '元丰天山花园(东门) 双流路267号' },
                { value: '钱记', address: '上海市长宁区天山西路' },
                { value: '壹杯加', address: '上海市长宁区通协路' },
                { value: '唦哇嘀咖', address: '上海市长宁区新泾镇金钟路999号2幢（B幢）第01层第1-02A单元' },
                { value: '爱茜茜里(西郊百联)', address: '长宁区仙霞西路88号1305室' },
                { value: '爱茜茜里(近铁广场)', address: '上海市普陀区真北路818号近铁城市广场北区地下二楼N-B2-O2-C商铺' },
                { value: '鲜果榨汁（金沙江路和美广店）', address: '普陀区金沙江路2239号金沙和美广场B1-10-6' },
                { value: '开心丽果（缤谷店）', address: '上海市长宁区威宁路天山路341号' },
                { value: '超级鸡车（丰庄路店）', address: '上海市嘉定区丰庄路240号' },
                { value: '妙生活果园（北新泾店）', address: '长宁区新渔路144号' },
                { value: '香宜度麻辣香锅', address: '长宁区淞虹路148号' },
                { value: '凡仔汉堡（老真北路店）', address: '上海市普陀区老真北路160号' },
                { value: '港式小铺', address: '上海市长宁区金钟路968号15楼15-105室' },
                { value: '蜀香源麻辣香锅（剑河路店）', address: '剑河路443-1' },
                { value: '北京饺子馆', address: '长宁区北新泾街道天山西路490-1号' },
                { value: '饭典*新简餐（凌空SOHO店）', address: '上海市长宁区金钟路968号9号楼地下一层9-83室' },
                { value: '焦耳·川式快餐（金钟路店）', address: '上海市金钟路633号地下一层甲部' },
                { value: '动力鸡车', address: '长宁区仙霞西路299弄3号101B' },
                { value: '浏阳蒸菜', address: '天山西路430号' },
                { value: '四海游龙（天山西路店）', address: '上海市长宁区天山西路' },
                { value: '樱花食堂（凌空店）', address: '上海市长宁区金钟路968号15楼15-105室' },
                { value: '壹分米客家传统调制米粉(天山店)', address: '天山西路428号' },
                { value: '福荣祥烧腊（平溪路店）', address: '上海市长宁区协和路福泉路255弄57-73号' },
                { value: '速记黄焖鸡米饭', address: '上海市长宁区北新泾街道金钟路180号1层01号摊位' },
                { value: '红辣椒麻辣烫', address: '上海市长宁区天山西路492号' },
                { value: '(小杨生煎)西郊百联餐厅', address: '长宁区仙霞西路88号百联2楼' },
                { value: '阳阳麻辣烫', address: '天山西路389号' },
                { value: '南拳妈妈龙虾盖浇饭', address: '普陀区金沙江路1699号鑫乐惠美食广场A13' }
            ];
        },
        handleSelect(item) {
            console.log(item);
        },
        handleIconClick(ev) {
            console.log(ev);
        }
    },
    mounted() {
        this.restaurants = this.loadAll();
    }
};
</script>
<style>
.my-autocomplete {
    li {
        line-height: normal;
        padding: 7px;

        .name {
            text-overflow: ellipsis;
            overflow: hidden;
        }
        .addr {
            font-size: 12px;
            color: #b4b4b4;
        }

        .highlighted .addr {
            color: #ddd;
        }
    }
}
</style>
